import { gql } from '@apollo/client'

export const transcribeBlogVideosMutation = gql`
  mutation transcribeBlogVideos($input: TranscribeBlogVideosArgs!) {
    transcribeBlogVideos(input: $input) {
      _id
      title
      contentHtml
      transcribingMetadata {
        status
        jobId
        startedAt
        videoCount
      }
      updatedAt
    }
  }
`
